import { t } from '@lingui/macro';
import { Address } from 'noddi-types';
import { NoddiBasicCard, NoddiFeedbackBox, useIsMobile, useScrollIntoView } from 'noddi-ui-web';
import { tracking } from 'noddi-web';
import { useEffect, useState } from 'react';

import { GoogleTrackingService } from '../../services/GoogleTrackingService';
import { GtmEvents } from '../../types/gtmTracking';
import { NoServiceOfferedForm } from './NoServiceOfferedForm';

type SelectedAddressDetailsProps = {
  address: Address;
  translations: {
    noServiceOfferedNotice: string;
  };
};

export const NoServiceOffered = ({ translations, address }: SelectedAddressDetailsProps) => {
  const isMobile = useIsMobile();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const containerRef = useScrollIntoView(!!address && isMobile);

  useEffect(() => {
    GoogleTrackingService.trackEvent(GtmEvents.noServiceOffered);
    tracking.track('noServiceOffered', address);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isFormSubmitted) {
    return (
      <div className='mt-4'>
        <NoddiFeedbackBox variant='success' description={t`Thank you! We’ll Keep You Updated`} />
      </div>
    );
  }
  return (
    <div ref={containerRef} className='mt-4'>
      <NoddiBasicCard className='flex flex-col gap-4'>
        <div>{translations.noServiceOfferedNotice} 😔</div>

        <NoServiceOfferedForm address={address} setIsFormSubmitted={setIsFormSubmitted} />
      </NoddiBasicCard>
    </div>
  );
};
